<template>
  <div class="mb-container">
    <answer-content
      :show="showAnswer"
      @toggleAnswer="showAnswer = !showAnswer"
      :question-list="questionList"
      :question-num="questionNum"
      :total-score="examineeInfo.score"
      :progress-width="progressWidth"
      :current-question-id="currentQuestionId"></answer-content>
    <question-content
      ref="questionDom"
      :question="currentQuestion"
      :hidden-prev="hiddenPrev"
      :testTime="testTime"
      :is-last="isLast"
      :new-countdown="newCountdown"
      :end-time="endTime"
      :question-num="questionNum"
      :totalFinish="questionList.totalFinish"
      :current-question-id="currentQuestionId"
      :operation-list="operationList"
      @closeShowLoading="closeShowLoading"
      @showSaveLoading="showSaveLoading = true"
      @saveAnswer="saveAnswer"
      @changeStyle="changeStyle"
      @openSlowTip="openSlowTip"
      @toggleAnswer="showAnswer = !showAnswer"
      @forceCompletedExam="forceSubmitForTimeEnd"
      @setIsNemoPageNow="setIsNemoPageNow"
    ></question-content>
    <!-- 保存答案 -->
    <div class="loading-mask" v-show="showSaveLoading">
      <div class="loading-wrap">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="30"
          class="loading-icon"
          color="#4C93FF"
        />
        <p>答案保存中...</p>
      </div>
    </div>
    <!-- 交卷结果提示 -->
    <mb-modal
      :showClose="false"
      :show.sync="showSubmitStatus"
      @confirm="submitConfirm"
      class="mb-submit-tip">
      <div slot="content">
        <div class="mb-icon">
          <img v-if="submitStatus === 0" src="~assets/images/exam/icon-fail.png" alt="">
          <img v-else  src="~assets/images/exam/icon-success.png" alt="">
        </div>
        <div class="tip">
          {{submitStatus === 0 ? '交卷失败' : '交卷成功'}}
        </div>
        <p class="tip-desc" v-if="submitStatus === 0">很遗憾试卷提交失败，请重新提交！</p>
        <p class="tip-desc" v-else>试卷提交成功，请尽快离开考场！</p>
      </div>
    </mb-modal>
    <!-- 确认交卷 -->
    <mb-modal
      :show.sync="showSubmit"
      title="确认交卷？"
      cancelBtnText="确认交卷"
      confirmBtnText="继续答题"
      @confirm="cancel"
      @cancel="submitTest"
      class="submit-tip">
      <div slot="content">
        <p v-if="!allDone">你还有<span class="total">{{questionNum - questionList.totalFinish}}</span>道试题未作答完成呢<br/>确定交卷吗？一旦交卷则不能再作答或修改答案</p>
        <p v-else>一旦交卷则不能再作答或修改答案</p>
      </div>
    </mb-modal>
    <!-- 倒计时三分钟提示 -->
    <mb-modal
      title="提示"
      confirmBtnText="知道了"
      :show.sync="showTimeoutTip"
      class="mb-submit-tip">
      <div slot="content">
        <p class="red">距离考试结束还有最后3分钟，请尽快答题哦～</p>
        <p> 一旦考试结束，系统将会自动收卷！</p>
      </div>
    </mb-modal>
    <!-- 自动收卷 -->
    <mb-modal
      title="提示"
      :showConfirmBtn="false"
      :showClose="false"
      :show.sync="autoSubmit"
      class="mb-submit-tip">
      <div slot="content">
        <icon-funnel class="funnel"></icon-funnel>
        <p>考试时间到，系统自动收卷中……</p>
      </div>
    </mb-modal>
    <!-- 提前交卷提示 -->
    <mb-modal
      title="提示"
      confirmBtnText="知道了"
      :show.sync="earlyTip"
      class="mb-submit-tip">
      <div slot="content">
        <p class="red">{{ (testInfo.start_time + earlySubmitMinute * 60 * 1000) | date('m月d日 H:i') }} 之前不允许交卷</p>
        <p>请考生仔细检查，遵照考试规定时间提交试卷。 </p>
      </div>
    </mb-modal>
    <!-- 退出当前页面提示 -->
    <mb-modal
      title="提示"
      :showClose="false"
      confirmBtnText="取消"
      cancelBtnText="退出"
      @confirm="backPrev"
      @cancel="backPrev(true)"
      class="mb-submit-tip"
      :show="showBackTip">
      <div slot="content">
        <p>是否后退，后退会导致退出考试。</p>
      </div>
    </mb-modal>
    <div v-if="showLoading" class="show-loading-icon">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="30"
        color="#3D81FF"
      />
    </div>
    <score :show.sync="scoreShow" v-if="scoreShow"></score>
    <!-- 切屏 -->
    <page-hidden-tip
      v-if="showPageHiddenTip"
      :no-record-page-hidden="noRecordPageHidden"
      :current-question="currentQuestion"
      :test-info="testInfo"
    ></page-hidden-tip>
    <!-- 网络慢 -->
    <slow-network-tip
      :show.sync="showSlowTip"
      :type="slowTipType" >
    </slow-network-tip>
    <!-- 考试终止 -->
    <mb-modal
      title="提示"
      :showClose="false"
      confirmBtnText="退出考试"
      @confirm="exitExam"
      :show="showForceExitModal">
      <div slot="content">
        <p>当前考试因故已被管理员终止，系统将在3秒内退出，请密切关注进一步通知</p>
      </div>
    </mb-modal>
  </div>
</template>

<script>
import AnswerContent from './AnswerContent'
import QuestionContent from './QuestionContent'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import { get, post } from '@/utils/ajax'
import { mapMutations, mapState } from 'vuex'
import MbModal from '@/components/MbModal'
import { setTimeout } from 'timers'
import IconFunnel from '@/assets/svg/icon-funnel.svg'
import PageHiddenTip from './PageHiddenTip'
import Score from './Score'
import SlowNetworkTip from './SlowNetworkTip'
import {
  SHOW_PREVIEW,
  DISMISS_REMIND_BTN,
  REQUEST_DIFF_TIME,
  DIFF_TIME_END,
  FORCE_COMPLETED_CREATION,
  EXAM_COMPLETED,
  postMessageSyn,
  onPostMessageSynRegister,
  removeOnPostMessageSynRegister
} from '@/utils/dsbridge'

export default {
  components: {
    SlowNetworkTip,
    PageHiddenTip,
    Score,
    IconFunnel,
    MbModal,
    AnswerContent,
    QuestionContent,
    LoopingRhombusesSpinner
  },
  props: {
    showBackTip: Boolean,
    backPrev: Function
  },
  data () {
    return {
      earlyTip: false,
      newCountdown: 0, // 远程时间
      originTime: 0,
      endTime: 0, // 远程时间倒计时时间戳
      testTime: 0, // 时间记录：1 距离倒计时3分钟 2 结束
      loadingTime: 0, // loading开始时间
      showLoadingTime: 0,
      scoreShow: false,
      showSubmit: false,
      date: '',
      currentQuestion: {},
      currentQuestionId: 0,
      testInfo: {},
      questionList: {},
      indexList: [], // 题目id数组
      questionNum: 0,
      progressWidth: '0px',
      hiddenPrev: false,
      isLast: false,
      allDone: false,
      showTimeoutTip: false,
      autoSubmit: false,
      submitStatus: 2, // 0-提交失败 1-提交成功
      showSubmitStatus: false,
      examName: '',
      showLoading: false,
      showSaveLoading: false,
      countdown: 30,
      submitTimer: null,
      showUnusualCommit: false,
      showPageHiddenTip: false, // 展示切屏警告
      pageHiddenCount: 0,
      noRecordPageHidden: false,
      examConfig: {},
      showUnusual: false,
      openAgoraMonitor: true,
      openCamera: false,
      openPhotoMonitor: false,
      openExamNotice: false,
      monitorInfo: {},
      agoraOption: {},
      fullScreen: false,
      showCameraErrorTip: false,
      earlySubmitMinute: 0,
      returnRoute: 'list',
      msgTimer: null,
      hasUnReadMsg: false,
      unReadMsg: '', // 问题上报未读消息
      unReadCount: 0, // 问题上报未读消息数量
      timeDiff: 0, // 服务器与本地时间差
      diffX: 0,
      diffY: 0,
      draging: false,
      showSlowTip: false,
      slowTipType: 'loadQues',
      operationList: [],
      showForceExitModal: false,
      showAnswer: false,
      isNemoPageNow: false,
      submitTestLoading: false // 是否交卷中
    }
  },
  computed: {
    ...mapState(['weishengRoute', 'eduteacherRoute']),
    user() {
      return this.$store.state.user
    },
    examineeInfo () {
      return this.$store.state.examineeInfo
    }
  },
  watch: {
    testTime (n) {
      // 倒计时3分钟提醒
      if (n === 1) {
        this.showTimeoutTip = true
      }
      // 倒计时结束自动交卷（慎用）
      if (n === 2) {
        this.showTimeoutTip = false
        this.autoSubmit = true
        // console.log('WEB端时间到了，通知app自动收卷 => 推送FORCE_COMPLETED_CREATION')
        postMessageSyn(FORCE_COMPLETED_CREATION) // 通知app自动收卷
        // 展示自动收卷  且当前nemo已经响应 COMPLETED_CREATION 事件给到答案 实际收卷动作在 COMPLETED_CREATION 回调中完成
        !this.isNemoPageNow && setTimeout(this.forceSubmitForTimeEnd, 1000)
      }
    },
    currentQuestionId (newV) {
      if (newV && typeof newV === 'number') {
        // 对比
        if (this.examineeInfo.exam_id) {
          const userId = this.user.id
          localStorage.setItem('currentQuestionIdComparison', `${newV}&&${this.examineeInfo.exam_id}&&${userId}`)
        }
      }
    }
  },
  async mounted () {
    await this.getTestInfo()
    this.initHandleForApp()
  },
  methods: {
    ...mapMutations({
      setExaminee: 'SET_EXAMINEE_INFO'
    }),
    dismiss() {
      postMessageSyn(DISMISS_REMIND_BTN)
    },
    initHandleForApp() {
      this.onDiffTimeEndWithApp()
      this.onReturnDiffTimeForApp()
    },
    // 设置标志位
    setIsNemoPageNow(isNemoPageNow) {
      this.isNemoPageNow = isNemoPageNow
    },
    // app端确认时间结束
    onDiffTimeEndWithApp() {
      onPostMessageSynRegister(DIFF_TIME_END, (res) => {
        // const time = this.endTime - this.newCountdown
        // console.log(`APP触发 => DIFF_TIME_END => 当前endTime: ${this.endTime} time: ${time}`)
        // 考试剩余时间，可以为负数
        if (!this.endTime || this.endTime === 0) {
          // console.log('DIFF_TIME_END => 主动推送强制收卷 => FORCE_COMPLETED_CREATION')
          postMessageSyn(FORCE_COMPLETED_CREATION)
          return '1' // 已经结束
        } else {
          return '0' // 未结束
        }
      })
    },
    // app端调用获取倒计时时间 通知App剩余考试毫秒数
    onReturnDiffTimeForApp() {
      onPostMessageSynRegister(REQUEST_DIFF_TIME, () => {
        const time = this.endTime - this.newCountdown
        // postMessageSyn(RETURN_DIFF_TIME, { mills: time })
        /* console.log(`
          APP触发 REQUEST_DIFF_TIME =>
          endTime: ${this.endTime}
          newCountdown: ${this.newCountdown}
          获取时间time: ${time}
          倒计时: ${timeFactory(time)}`) */
        return time + ''
      })
    },
    // 移除注册事件
    removeAppRegister() {
      removeOnPostMessageSynRegister(REQUEST_DIFF_TIME)
      removeOnPostMessageSynRegister(DIFF_TIME_END)
    },
    // 2.获取远程时间，开始倒计时，时间3分钟提醒，时间结束交卷退出
    async getTime () {
      const time = await this.setTimeDiff()
      this.newCountdown = time
      // 初始化一次
      this.showLoadingTime = time
      this.originTime = time
      const time1 = +Date.now()
      const diff = this.timeDiff
      this.timer = setInterval(() => {
        const time2 = +Date.now()
        const accuracy = time2 - time1 + this.timeDiff - diff
        this.startTime(accuracy)
      }, 1000)
    },
    // 时间操作
    async startTime (accuracy) {
      this.newCountdown = this.originTime + accuracy

      // 考试剩余时间，可以为负数
      if (!this.endTime || this.endTime === 0) {
        // postMessageSyn(DIFF_TIME_END, { examId: this.currentQuestion.examId })
        return
      }
      const time = this.endTime - this.newCountdown
      // 一秒的差额下变动
      if (time < 3 * 60000 && time > (3 * 60000 - 1000)) {
        this.testTime = 1
      } else if (time <= 0) {
        // 交卷之前校验本地与服务器时间
        const serverTime = await this.setTimeDiff()
        if (this.endTime - serverTime <= 0) {
          this.testTime = 2
        }
        clearInterval(this.timer)
        this.timer = null
      }
      // loading图出现时间不超过20秒
      if (!this.showSaveLoading) { // 答案保存loading
        this.loadingTime = this.newCountdown
      } else if (this.newCountdown - this.loadingTime > 1000 * 20) {
        this.openSlowTip('saveSlow')
        this.showSaveLoading = false
      }
      // loading图出现时间不超过20秒
      if (!this.showLoading) { // 题目加载loading
        this.showLoadingTime = this.newCountdown
      } else if (this.newCountdown - this.showLoadingTime > 1000 * 20) {
        if (this.currentQuestion.typeId !== 11) { // kitten/scratch操作题不做20s限制
          this.openSlowTip('loadQues')
          this.closeShowLoading()
        }
      }
      if (parseInt(accuracy / 1000) % 60 === 0) {
        // 60秒执行一次，获取后台考试配置 TODO
        this.check(localStorage.examId)
        // 获取考试结束时间
        this.checkEndTime()
        this.setTimeDiff()
      }
    },
    // 获取服务器时间
    async getSeverTime() {
      const data = await get('/home/common/times')
      return data
    },
    // 设置本地与服务器时间差
    async setTimeDiff() {
      const serverTime = await this.getSeverTime()
      this.timeDiff = serverTime - Date.now()
      return serverTime
    },
    closeShowLoading() {
      this.showLoading = false
      this.showLoadingTime = this.newCountdown
    },
    // 1.获取考生信息
    async getTestInfo () {
      try {
        this.testInfo = await get(`/home/exams/${localStorage.examId}/examinees/${localStorage.user_id}/profile`)
        // 4-8 不可答题
        if (this.testInfo.examinee_status === 0 || this.testInfo.examinee_status >= 4) {
          this.$message.info('考试未开始或已结束')
          localStorage.goList = '1'
          this.$router.push({ name: 'list', params: { noBackTip: true } })
        } else {
          this.testInfo.exam_id = localStorage.examId
          this.setExaminee(this.testInfo)
          await this.initTest()
          // Nemo内打开监控
          postMessageSyn(SHOW_PREVIEW)
        }
      } catch (e) {
        console.log(e)
        this.$message.info('考试未开始或已结束')
        this.$router.push({ name: 'list', params: { noBackTip: true } })
      }
    },
    // 开始考试获取各种数据
    async initTest() {
      this.getTime()
      this.getTestProcess()
      await this.check(localStorage.examId)
      this.beforeunloadFun = (e) => {
        (e || window.event).returnValue = true
        this.noRecordPageHidden = true
      }
      window.addEventListener('beforeunload', this.beforeunloadFun) // 监听页面刷新或关闭标签页事件
      this.$store.dispatch('setMonitorReport', { type: 4 }) // 上报考试监控埋点，开始答题
    },
    // 2.获取考卷信息
    async getTestProcess () {
      const data = await get(`/home/edu/examinees/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}/progress`)

      this.examName = this.examName ? this.examName : data.examName
      // 结束时间
      this.endTime = data.endTime
      // 题目个数
      this.questionNum = data.questionList.length
      // 答题卡json组装后渲染
      this.initAnswerArea(data.questionList)
      // 拿到第一个题目id开始渲染答题区 优化
      const currentQuestionIdComparison = localStorage.getItem('currentQuestionIdComparison') || ''
      const [questionId, examId, userId] = currentQuestionIdComparison.split('&&')
      if (+questionId && +examId === +this.examineeInfo.exam_id && +userId === this.user.id) {
        this.getQuestionInfo(+questionId)
      } else {
        this.getQuestionInfo(data.questionList[0].questionId)
      }
    },
    // 3.当前题目详情区（题型，题目，选项，答案）获取题目信息延长loading
    async getQuestionInfo (id) {
      if (!id) return
      try {
        this.showLoading = true
        this.currentQuestion = {}
        this.currentQuestionId = id

        // 隐藏上一题
        this.hiddenPrev = id === this.indexList[0]
        // 隐藏下一题
        this.isLast = id === this.indexList[this.indexList.length - 1]
        // 获取当前题目详情（后期可改，放入数据库）
        this.currentQuestion = await get(`/home/edu/questions/${this.examineeInfo.exam_id}/${id}/${this.examineeInfo.examinee_id}`, {}, { ignoreMsg: true })
        // this.showLoading = false
        // 加入kitten加载时间逻辑
        if (
          this.currentQuestion.typeId !== 11 ||
          (this.currentQuestion.typeId === 11 && this.currentQuestion.questionType === 4)
        ) {
          this.showLoading = false
        }
      } catch (e) {
        this.handleError(e)
      }
    },
    cancel () {
      this.showSubmit = false
    },
    // 3.组装答题卡区（题目列表，当前题目id，进度）
    initAnswerArea (data) {
      const typeArr = []
      const questionObj = {}
      this.operationList = []
      const quesTypes = {}
      // 完成数记录
      let totalFinish = 0
      data.forEach((t, i) => {
        this.indexList.push(t.questionId)
        if (t.done) totalFinish++
        if (!questionObj[t.typeName]) {
          typeArr.push({
            typeName: t.typeName,
            typeId: t.typeId,
            isHidden: false,
            indexList: [{
              id: t.questionId,
              questionType: t.questionType,
              index: i + 1,
              isFinish: t.done
            }]
          })
          questionObj[t.typeName] = t
        } else {
          typeArr.forEach(_t => {
            if (_t.typeName === t.typeName) {
              _t.indexList.push({
                id: t.questionId,
                questionType: t.questionType,
                index: i + 1,
                isFinish: t.done
              })
            }
          })
        }
        if (!quesTypes[t.questionType]) {
          if (t.questionType >= 0 && t.questionType !== 1) { // 获取每种类型操作题第一个题目位置
            this.operationList.push({
              typeId: t.typeId,
              questionNo: t.questionNo,
              questionType: t.questionType,
              preQuesId: i > 0 ? data[i - 1].questionId : null
            })
          }
          quesTypes[t.questionType] = 1
        }
      })
      this.progressWidth = totalFinish * 280 / this.questionNum + 'px'
      // 按题目归类（list:[{typeName: '单项选择', isHidden: false, indexList: [...]}, ...]）
      this.questionList = {
        totalFinish,
        list: typeArr
      }
    },
    async checkTestFinish () {
      try {
        const { allDone } = await get(`/home/edu/examinees/check/${localStorage.examId}/${this.testInfo.examinee_id}`, {}, { ignoreMsg: true })
        this.allDone = allDone
        this.showSubmit = true
      } catch (e) {
        this.handleError(e)
      }
    },
    // 最早交卷控制
    async earlyControl () {
      // 设置了最早交卷且没超过最早交卷时间就提示不能交卷
      const time = await get('/home/common/times')
      if (this.earlySubmitMinute && time - this.testInfo.start_time <= this.earlySubmitMinute * 60 * 1000) {
        this.earlyTip = true
      } else {
        await this.checkTestFinish()
      }
    },
    // 倒计时结束强制交卷
    async forceSubmitForTimeEnd() {
      // console.log(`【index】forceSubmitForTimeEnd 当前倒计时结束，系统收卷。 isNemoPageNow: ${this.isNemoPageNow}`)
      await this.saveCurAnswerAndSubmit(2, 'saveNemo')
    },
    // 保存当前问题答案
    async saveCurAnswerAndSubmit(type, which = '') {
      const answer = this.$refs.questionDom.answerHasNotChange ? null : this.$refs.questionDom.currentAnswer
      // console.log(`保存当前问题答案并提交试卷 => type: ${type}, which: ${which}, answer =>`, answer)
      // 自动收卷要特殊处理主观题，考生打开了编辑器，那时收卷要保存题目
      if (this.$refs.questionDom.editorFullScreen) {
        // 涉及异步 message事件
        await this.$refs.questionDom.outFullScreen()
        return
      }
      // 除主观题之外的提交
      if (answer) {
        await this.save({
          which,
          answer,
          currentId: this.currentQuestionId
        })
      }
      await this.submitTest(type)
    },
    async saveAnswer (data) {
      // console.log('【index】触发 saveAnswer =>', data)
      data.answer ? this.save(data) : this.changeQuestion(data)
    },
    // 根据功能（点击题目,保存主观题,点击上/下一题）
    async changeQuestion (data) {
      // 加载时或者极限切题时 不允许切题
      if (this.showLoading || this.newCountdown - this.showLoadingTime > 1000 * 20) return
      if (data.which === 'submitPaper') {
        this.earlyControl()
        return
      }
      if (['saveKitten', 'savePython', 'saveScratch', 'saveNemo', 'saveCplusplus'].includes(data.which)) {
        this.changeQuestionStatus(this.currentQuestion.questionId)
        // 到点收卷
        if (this.testTime === 2) {
          this.submitTest(2)
        }
        return
      }
      let id
      switch (data.which) {
        case 'nextQuestion':
          id = this.indexList[this.indexList.findIndex(t => t === data.currentId) + 1]
          break
        case 'prevQuestion':
          id = this.indexList[this.indexList.findIndex(t => t === data.currentId) - 1]
          break
        case 'selectQuestion':
          id = data.currentId
          break
      }
      // 切换题目需要当前id,拉取题目详情
      this.currentQuestionId = id
      this.getQuestionInfo(id)
    },
    // 保存题目
    async save (data) {
      let multipleArr
      if (this.currentQuestion.typeId === 2) multipleArr = data.answer.join(',')
      const answer = data.answer.url || data.answer
      const isExcludeNemo = (this.currentQuestion.typeId === 11 && this.currentQuestion.questionType !== 4)
      const params = {
        examId: this.examineeInfo.exam_id,
        examineeId: this.examineeInfo.examinee_id,
        questionId: isExcludeNemo ? (data.answer.questionId || data.currentId) : this.currentQuestion.questionId,
        questionNo: isExcludeNemo ? (data.questionNo || data.answer.questionNo) : this.currentQuestion.questionNo,
        typeId: this.currentQuestion.typeId,
        answer: this.currentQuestion.typeId === 2 ? multipleArr : answer,
        workId: data.answer.workId || null
      }
      // console.log('执行save => 提交题目', params, data)
      try {
        await post('/home/edu/examineeExamRecode/answer', params, { ignoreMsg: true })
        // console.log('执行save => 提交题目成功')
        this.showSaveLoading = false
        this.changeQuestionStatus(this.currentQuestion.questionId)
        if (data.which === 'submitPaper') {
          await this.earlyControl()
        } else if ([
          'saveKitten',
          'savePython',
          'saveScratch',
          'saveNemo',
          'saveCplusplus'
        ].includes(data.which)) {
          this.$message.success('保存成功')
          await this.changeQuestion(data)
        } else if (data.which !== 'saveTextarea') {
          await this.changeQuestion(data)
        }
      } catch (e) {
        this.handleError(e)
      }
    },
    // 改变题目状态和答题进度
    changeQuestionStatus (currentId) {
      let totalFinish = 0
      this.questionList.list.forEach(t => {
        t.indexList.forEach(_t => {
          if (_t.isFinish) totalFinish++
          if (_t.id === currentId && !_t.isFinish) {
            _t.isFinish = true
            totalFinish++
          }
        })
      })
      this.progressWidth = totalFinish * 280 / this.questionNum + 'px'
      this.questionList.totalFinish = totalFinish
    },
    // 提交答卷
    async submitTest (type) {
      // type 1-正常交卷 2-系统交卷 3-强制交卷

      if (type !== 3) {
        // 提交答卷前检测是否延长考试
        const hasDelayTime = await this.checkEndTime()
        if (hasDelayTime) {
          return
        }
      }

      const func = await this.funcAPI()
      // const func = true
      if (!func) {
        return true
      } else {
        try {
          // console.log(`【index】执行 提交试卷, type: ${type}`)
          this.timer && clearInterval(this.timer)
          this.submitTestLoading = true
          await post(`/home/edu/examinees/end/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}`)
          this.submitTestLoading = false
          // 清除答题进度
          localStorage.removeItem('currentQuestionIdComparison')
          // 通知app考试结束
          postMessageSyn(EXAM_COMPLETED, { examId: this.examineeInfo.exam_id })
          if (type !== 3) {
            this.autoSubmit = false
            this.showSubmit = false
            this.submitStatus = 1
            this.submitTimer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--
              }
              if (this.countdown === 0) {
                this.submitConfirm()
              }
            }, 1000)
            if (this.testInfo.show_grade === 1) {
              this.scoreShow = true
            } else {
              this.showSubmitStatus = true
            }
            // 获取监控信息
            // this.getMonitorInfo()
            window.onblur = null
            window.removeEventListener('beforeunload', this.beforeunloadFun)
          }
        } catch (e) {
          this.submitStatus = 0
          this.showSubmitStatus = true
          console.log(e)
        }
      }
    },
    async funcAPI () {
      let isOk = true
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        try {
          const res = await post('/home/outsize/weisheng/users', { uniqId: localStorage.UniqId })
          isOk = res.data.isOk
          if (!isOk) {
            this.$message(res.error.message || '威盛登录态失效,请重新登录！')
            return false
          } else {
            return true
          }
        } catch (error) {
          // console.log(error)
          this.$message('威盛登录态失效,请重新登录！')
          return false
        }
      }
      if (this.$route.path.split('/')[1].indexOf(this.eduteacherRoute) >= 0) {
        try {
          const info = JSON.parse(localStorage.eduTeacher)
          if (!info['exam' + localStorage.examId]) {
            this.$message('解析失败，请由未来教室跳转进入考试')
            return false
          }
          const infoItem = info['exam' + localStorage.examId]
          if (infoItem.userId.toString() !== localStorage.user_id.toString()) {
            this.$message('解析失败，请勿切换账号，请由未来教室跳转进入考试')
            return false
          }
          return true
        } catch (error) {
          this.$message('解析失败，请由未来教室跳转进入考试')
          localStorage.removeItem('eduTeacher')
          return false
        }
      }
      return true
    },
    async submitConfirm () {
      // 加逻辑
      this.showSubmitStatus = false
      this.handleReturnRoute()
    },
    // 取消上报异常
    cancelUnusualCommit () {
      this.showUnusualCommit = false
    },
    // 上报异常
    async commitUnusual (data) {
      const { description, type } = data
      try {
        await post(`/home/unusual_pools`, {
          description,
          type,
          examId: localStorage.examId,
          submitNumber: this.currentQuestion.questionNo,
          userId: this.user.id,
          admissionTicket: this.testInfo.admission_ticket
        })
        this.$message.success('你的问题已收到，请继续进行下一道题的作答，考试结束后工作人员将就您上报的问题进行跟进处理。')
        // 上传成功，关闭弹框
        this.cancelUnusualCommit()
      } catch (e) {
        this.$message.error('提交失败，请重试！')
      }
    },
    // 获取后台考试配置开关（身份核验，反作弊，问题上报，切屏监控等）
    async check (examId) {
      const { exam_config, early_submit_minute } = await get(`/home/exams/check/${examId}`)
      exam_config.forEach(item => {
        const label = item.label.split('#')[1]
        this.examConfig[label] = item.actual_value
      })
      this.showUnusual = this.examConfig['unusual_report'] === '1'
      this.openCamera = this.examConfig['float_video_window'] === '1'
      this.openAgoraMonitor = this.examConfig['keep_video_record'] === '1'
      // if (this.openAgoraMonitor && !this.agoraOption.uid) { // 获取声网录制token
      //   this.getAgoraToken()
      // }
      this.openPhotoMonitor = this.examConfig['ai_check'] === '1'
      this.showPageHiddenTip = this.examConfig['switch_screen'] === '1'
      this.earlySubmitMinute = early_submit_minute
    },
    // 摄像头打开失败
    cameraError(type) {
      this.showCameraErrorTip = true
    },
    // 获取监控的异常统计
    async getMonitorInfo() {
      this.monitorInfo = await get(`/home/unusual_pools/examinees/${this.examineeInfo.examinee_id}`)
    },
    // 获取声网录制token
    async getAgoraToken() {
      const params = {
        userId: this.user.id,
        examId: localStorage.examId
      }
      const data = await get(`/home/ai-invigilate/agora-token`, params)
      this.agoraOption = Object.assign({}, data)
    },
    // 打开操做题全屏修改右侧布局样式
    changeStyle(flag) {
      this.fullScreen = flag
    },
    // 拍照上报，监控异常行为
    async photoReport(url) {
      const params = {
        currentPhoto: url,
        deviceId: this.$store.state.browserFinger,
        examId: localStorage.examId,
        timestamp: Date.now(),
        userId: this.user.id
      }
      const { normal, dystropyType } = await post(`/home/ai-invigilate/invigilate-note`, params)
      if (!normal) { // 行为不正常
        let tip = ''
        switch (dystropyType) {
          case 2:
            tip = '监测到离开摄像头'
            // tip = '监考系统检测到您已离开摄像头，该行为涉嫌严重违反在线考试规则，考试结束后将进行人工核查确认您是否违规，请先继续完成考试。'
            break
          case 3:
            tip = '监测到多人'
            // tip = '监考系统检测到有多人出现在摄像头前，该行为涉嫌严重违反在线考试规则，考试结束后将进行人工核查确认您是否违规，请先继续完成考试。'
            break
          case 4:
            tip = '监测到非本人'
            // tip = '监考系统检测到非本人出现在摄像头前，该行为涉嫌作弊，已被监考系统上报，考试结束后将进行人工核查确认您是否作弊，请先继续完成考试。'
            break
        }
        if (tip) {
          this.$message({
            type: 'warning',
            message: tip,
            duration: 6000
          })
        }
      }
    },
    openSlowTip(type) {
      this.slowTipType = type
      this.showSlowTip = true
    },
    async handleError(e) {
      if (e.error_code === 20612002) { // 考试时间到点自动收卷 or 单个考生强制收卷
        // 关闭监控视频流
        const monitor = this.$refs.agoraRtcMonitor
        if (monitor) {
          await monitor.leave()
          await monitor.closeTimer()
        }
        this.submitConfirm()
      } else if (e.error_code === 20612004) { // 后台整场终止
        this.quitExam()
      } else if (e.error_code === 20612005) { // 换考
        this.$message({
          type: 'warning',
          message: '考生对应考试已换考',
          onClose: this.exitExam
        })
      } else {
        !this.isNemoApp && this.$message.error(`${e.error_msg || '未知错误'}`)
      }
    },
    // 获取考试结束时间
    async checkEndTime() {
      let hasDelayTime = false
      try {
        const { endTime } = await get(`/home/edu/examinees/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}/progress`, {}, { ignoreMsg: true })
        if (endTime && this.endTime < endTime) {
          const diff = parseInt((endTime - this.endTime) / 1000 / 60)
          if (diff !== 0) {
            this.endTime = endTime
            this.autoSubmit = false
            this.showSubmitStatus = false
            this.testTime = 0
            if (diff > 3) {
              this.showTimeoutTip = false
            }
            hasDelayTime = true
            this.$message.warning(`当前考试因故延长时间${diff}分钟`)
          }
        }
      } catch (e) {
        this.handleError(e)
      }
      return hasDelayTime
    },
    quitExam() {
      if (this.submitTimer) {
        return
      }
      this.showForceExitModal = true
      this.submitTimer = setTimeout(() => {
        this.exitExam()
        clearInterval(this.submitTimer)
      }, 3000)
    },
    async exitExam() {
      this.showForceExitModal = false
      await this.saveCurAnswerAndSubmit(3)
      this.handleReturnRoute()
    },
    async handleReturnRoute() {
      try {
        window.removeEventListener('beforeunload', this.beforeunloadFun)
        // 隐藏视频录制提示按钮
        await postMessageSyn(DISMISS_REMIND_BTN)
        // 回到候考页
        this.$router.replace({ name: 'pretest', params: { noBackTip: true } })
        // window.location.href = window.CONFIG.m_top_noc
      } catch (error) {
        console.error(error)
      }
    }
  },
  destroyed () {
    // 隐藏视频录制提示按钮
    postMessageSyn(DISMISS_REMIND_BTN)
    window.onblur = null
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.submitTimer)
    this.submitTimer = null
    window.removeEventListener('beforeunload', this.beforeunloadFun)
    clearTimeout(this.msgTimer)
    this.msgTimer = null
    this.removeAppRegister()
  }
}
</script>
<style>
#zc__bubble_container{
  display: none;
}
</style>
<style lang="scss" scoped>
.mb-container{
  height: 100%;
}
.monitor-wrap{
  position: fixed;
  right: 80px;
  bottom: 107px;
  width: 240px;
  height: 160px;
  cursor: pointer;
  z-index: 6;
  /deep/ .camera-monitor{
    position: initial;
    right: initial;
    bottom: initial;
  }
}
.translate-left-enter-active{
  transition: all ease-in-out 0.5s;
}
.translate-left-leave-active{
  transition: all ease 0.2s;
}
.translate-left-enter-to, .translate-left-leave{
  max-width: 456px;
}
.translate-left-enter, .translate-left-leave-to{
  max-width: 60px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.show-loading-icon {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}
.test-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  display: flex;
  flex-direction: column;
}
.header {
  width: 100%;
  height: 257px;
  min-height: 257px;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 40px 0;
  z-index: 1;
  overflow: hidden;
  .bg {
    position: absolute;
    width: 18000px;
    height: 18000px;
    border-radius: 50%;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }
  .title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    line-height: 42px;
    padding-top: 45px;
  }
  .right-content {
    display: flex;
  }
  .error-report::after, .error-report .msg::after{
    display: block;
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-style: solid;
    border-width: 15px;
    transform: rotate(10deg);
    border-radius: 11px;
  }
  .error-report {
    position: relative;
    width: 132px;
    height: 40px;
    padding: 0 15px;
    margin: 36px 28px 0 0;
    font-size: 16px;
    color: $themeColor;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: #fff;
    box-shadow: 0 2px 6px 0 rgba(156, 156, 156, 0.5);
    border-radius: 30px;
    &::after{
      border-color: transparent transparent transparent #fff;
      bottom: -13px;
      left: 18px;
    }
    .icon-question{
      fill: inherit;
      z-index: 2;
    }
    .text{
      margin-left: 10px;
      user-select: none;
    }
    .count{
      position: absolute;
      right: -7px;
      top: -10px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #f5222d;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      font-weight: 500;
      i{
        width: 3px;
        height: 3px;
        background: #fff;
        border-radius: 50%;
        margin: 0 1px;
        display: inline-block;
      }
    }
    .msg{
      position: absolute;
      transform: translate(calc(-100% - 25px), -50%);
      line-height: 40px;
      padding: 0 26px;
      height: 40px;
      color: inherit;
      background: #fff;
      box-shadow: inherit;
      border-radius: 20px;
      span{
        min-width: 60px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 456px;
      }
      &::after{
        border-color: transparent;
        border-right-color: #fff;
        bottom: -9px;
        right: 18px;
      }
    }
  }
  .countdown {
    width: 360px;
    height: 48px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 32px;
    margin-top: 36px;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 24px;
      background-color: rgba(0, 0, 0, 0.15);
      z-index: -1;
    }
    .clock {
      display: inline-block;
      width: 19px;
      height: 21px;
      background: url('~images/clock.png')no-repeat center / cover;
      margin-right: 10px;
    }
    .word {
      font-size: 18px;
      color: #fff;
      margin-right: 20px;
      font-weight: 300;
    }
    .time {
      font-size: 32px;
      font-weight: 500;
      color: #fff;
    }
  }
}
.test-content {
  width: 100%;
  height: calc(100% - 110px);
  flex: 1;
  display: flex;
  padding: 0 40px;
  // position: relative;
  z-index: 2;
  margin-top: -157px;
}
.mb-submit-tip {
  .mb-icon{
    margin: 48px auto 19px;
    img{
      width: 96px;
      height: 96px;
    }
  }
  .tip {
   font-size: 34px;
    font-weight: 500;
    color: #333333;
    line-height: 48px;
  }
  .red{
    color: #DB0A0A;
  }
  .tip-desc {
    margin-top: 4px;
    font-size: 30px;
    font-weight: 400;
    color: #666666;
    line-height: 44px;
  }
  .funnel{
    fill:#3D81FF;
    margin-bottom: 10px;
  }
}
.timeout-tip {
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    .icon {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  .big-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .small-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
  .tip-desc {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    font-weight: 300;
    text-align: center;
    &.red {
      color: #f5222d;
    }
  }
}
.tip-early {
  text-align: center;
  font-size: 16px;
  color: #333;
  line-height: 28px;
  font-weight: 300;
  &.red {
    color: #F5222D;
  }
}
.modal-btn {
  margin: 30px 0 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  .continue {
    @include theme-fill-btn(104px, 36px, 14px, 4px);
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    p {
      font-size: 14px;
      margin-top: 20px;
      color: #4C93FF;
    }
  }
}
.total {
  margin: 0 2px;
  color: #DB0A0A;
  font-weight: 600;
}
.back-tip-modal {
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .tip-content {
    margin-bottom: 35px;
  }
}
.camera-monitor {
  position: fixed;
  right: 80px;
  bottom: 107px;
  z-index: 2;
}
.full-camera-monitor {
  right: 120px;
  z-index: -100;
}
</style>

<style lang="scss">
  .test-container {
    .btn-wrap {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .continue {
        @include theme-fill-btn(96px, 36px, 14px, 4px);
        margin-left: 20px;
        margin-bottom: 10px;
      }
      .cancel {
        @include cancel-btn(96px, 36px, 14px, 4px);
      }
    }
  }
  .before-leave-box /deep/ {
    .el-message-box__content {
      width: 100%;
      padding-top: 50px;
    }
    .el-message-box__btns {
      padding: 40px 0 20px 0;
      display: flex;
      justify-content: flex-end;
      .el-button {
        font-size: 16px;
        margin: 0;
      }
      .confirm-btn {
        margin: 0 20px;
        @include cancel-btn(96px, 36px, 14px, 4px);
        border: 1px solid $themeColor;
        color: $themeColor;
      }
      .cancel-btn {
        @include theme-fill-btn(96px, 36px, 14px, 4px);
        line-height: 1;
      }
    }
  }
  .save-success-modal {
    /deep/ .dialog {
      text-align: center;
      .content {
        padding: 10px 20px ;
      }
    }
    .tip-early {
      margin: 10px 0 25px 0;
    }
    .continue {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
    }
    .success-icon {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      margin: 20px auto auto;
      background: rgba(57, 126, 253, .2) url('~images/success@2x.png') no-repeat center / 28px 28px;
    }
  }
  .report-modal {
    .tip {
      display: flex;
      margin-top: -15px;
      margin-bottom: 20px;
      font-weight: 300;
      span {
        display: inline-block;
      }
      .title {
        width: 81px;
        margin-right: 12px;
        text-align: right;
        font-weight: 400;
      }
      .text {
        flex: 1;
      }
      a {
        color: $themeColor;
        cursor: pointer;
        font-weight: 400;
      }
    }
  }
</style>
